import { Component, Inject, PipeTransform } from '@angular/core';
import { Constants } from '../../../../utils/constants';
import { InternalEquipmentBalanceMass } from '../../../../model/internalEquipmentBalanceMass';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ThemeService } from '../../../../services/theme.service';
import { VariableUnit } from '../../../../model/variable';
import { Subject, takeUntil } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
import { VariableTypeService } from '../../../../services/variableType.service';

export interface DialogDataBalanceMass {
  item: InternalEquipmentBalanceMass;
  idVariable: number;
}

@Component({
  selector: 'app-internal-equipment-edit-balance-mass',
  templateUrl: './internal-equipment-edit-balance-mass.component.html',
  styleUrl: './internal-equipment-edit-balance-mass.component.scss',
  standalone: false
})
export class InternalEquipmentEditBalanceMassComponent {
  numberRegexp: RegExp = Constants.NUMBER_WITH_POINT_REGEXP;
  variableUnits: VariableUnit[];

  private destroy$ = new Subject<void>();

  constructor(
    private variableTypeService: VariableTypeService,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataBalanceMass,
    public dialogRef: MatDialogRef<InternalEquipmentEditBalanceMassComponent>,
    public dialog: MatDialog,
    private translate: TranslateService,
    private snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private themeService: ThemeService) { }

  ngOnInit(): void {
    if (!this.data.item) {
       this.data.item = new InternalEquipmentBalanceMass()
    }
    this.variableUnits = [];
   
    if (this.data.idVariable != null) {
      this.variableTypeService.findUnits(this.data.idVariable).pipe(takeUntil(this.destroy$)).subscribe((res: VariableUnit[]) => {
        this.variableUnits = res;

        if (this.data.item.idUnit == null || !this.variableUnits.map(v => v.id).includes(this.data.item.idUnit)) {
          this.onUnitChange(res[0]);
        }
      });
    }
    
  }

  onUnitChange(event: MatSelectChange | VariableUnit): void {

    let unit: VariableUnit;

    if (event instanceof MatSelectChange) {
      unit = this.variableUnits.find(v => v.id === event.value);
      
      if (unit) {
        this.data.item.idUnit = unit.id;
      }
    } else {
     this.data.item.idUnit =  event.id;
    }
  }

  onOkClick(): void {
    const errs = [];
    if (!this.data.item.idUnit) {
      errs.push(this.translate.instant('internalEquipmentEdit.balanceMass.cols.unit.error'));
    } else {
      if (this.data.item.mass && !this.numberRegexp.test(this.data.item.mass.toString())) {
        errs.push(this.translate.instant('internalEquipmentEdit.balanceMass.cols.mass.error'));
      } else if (this.data.item.valuePhysical && !this.numberRegexp.test(this.data.item.valuePhysical.toString())) {
        errs.push(this.translate.instant('internalEquipmentEdit.balanceMass.cols.physicalValue.error'));
      } else if (this.data.item.uncertaintyTypical && !this.numberRegexp.test(this.data.item.uncertaintyTypical.toString())) {
        errs.push(this.translate.instant('internalEquipmentEdit.balanceMass.cols.utip.error'));
      } else if (this.data.item.idMass && !this.numberRegexp.test(this.data.item.idMass.toString())) {
        errs.push(this.translate.instant('internalEquipmentEdit.balanceMass.cols.massId.error'));
      } 
    }
    
    if (errs.length === 0) {
      this.dialogRef.close(this.data.item);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
      this.spinnerService.hide();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }
}
